import $ from 'jquery';
import jsPlumb from 'jsplumb';
import { IS_A } from '~/scripts/constants/common-kids';
import Defaults from '~/scripts/constants/defaults';
import Relations from '~/scripts/services/relations';
import LinkStyle from './link-style';

export default class SchemaLink {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		Object.defineProperty(this, '__', { value: {} });
		this.$injector = $injector;

		/** @type {?jsPlumb.Connection} */
		this.connection = null;

		/** @type {boolean} */
		this.create = false;

		/** @type {?string} */
		this.dico_id = null;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = undefined;

		/** @type {{kid: import('@knitiv/api-client-javascript').LinkerKNode, name: string | undefined}} */
		this.linker = { kid: '0', name: undefined };

		/** @type {any} */
		this.data = {};

		/**
		 * @type {{
		 *   id: string | undefined,
		 *   kid: import('@knitiv/api-client-javascript').KNode | undefined,
		 *   card: number
		 * }}
		 */
		this.from = {
			id:   undefined,
			kid:  undefined,
			card: Defaults.schema.DEFAULT_CARD_FROM,
		};

		/** @type {boolean} */
		this.readOnly = false;

		/** @type {any[]} */
		this.relations = [];

		/** @type {boolean} */
		this.selected = false;

		/** @type {LinkStyle} */
		this.style = new LinkStyle();

		/**
		 * @type {{
		 *   id: string | undefined,
		 *   kid: import('@knitiv/api-client-javascript').KNode | undefined,
		 *   card: number
		 * }}
		 */
		this.to = {
			id:   undefined,
			kid:  undefined,
			card: Defaults.schema.DEFAULT_CARD_TO,
		};

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.type = Defaults.schema.DEFAULT_RELATION;

		(async () => {
			try {
				await this.loadRelations();
			}
			catch {
				this.relations.length = 0;
			}
		})();
	}

	export11() {
		return {
			data:     this.data,
			dico_id:  this.dico_id,
			from:     { kid: this.from.kid, card: this.from.card },
			kid:      this.kid,
			readOnly: this.readOnly,
			style:    this.style.export(),
			to:       { kid: this.to.kid, card: this.to.card },
			type:     this.type,
		};
	}

	export() {
		/** @type {any} */
		const link = {
			from:     { id: this.from.id },
			kid:      this.kid,
			readOnly: this.readOnly,
			style:    this.style.export(),
			to:       { id: this.to.id },
		};
		if (this.dico_id === undefined) {
			link.data = this.data;
			link.from.card = this.from.card;
			link.to.card = this.to.card;
			link.type = this.type;
		}
		else {
			link.dico_id = this.dico_id;
		}
		return link;
	}

	/**
	 * Gets link connection
	 *
	 * @returns {?jsPlumb.Connection} jsPlumb link connection
	 */
	getConnection() {
		return this.connection;
	}

	getName() {
		return $('<div>').html(this.html()).text();
	}

	async loadRelations() {
		/** @type {any} */
		const result = await Relations.get(this.$injector);
		this.relations.push(...result);
	}

	/**
	 * Sets link connection
	 *
	 * @param {jsPlumb.Connection} connection jsPlumb link connection
	 */
	setConnection(connection) {
		this.connection = connection;
	}

	/**
	 * @param {jsPlumb.Connection} connection
	 */
	async setLabel(connection) {
		try {
			await this.loadRelations();
			// @ts-ignore
			connection.getOverlay('label')?.setLabel(this.html());
		}
		catch {
			// @ts-ignore
			connection.getOverlay('label')?.setLabel(this.type);
		}
	}

	html() {
		const relation = this.relations.find((/** @type {any} */ r) => r.kid === this.type);
		let name = relation?.name || this.type.split(';')[1];

		if (this.type !== IS_A) {
			name += ` (${this.from.card === Defaults.KCARDN ? 'N' : this.from.card},${this.to.card
			=== Defaults.KCARDN ? 'N' : this.to.card})`;
		}

		const $div = $('<div/>');

		if (this.linker && this.linker.kid !== '0') {
			$div.append($('<span/>').addClass('linker').text(`${this.linker.name} ` || ''));
		}

		$div.append($('<span/>').addClass('nom').text(name));
		if (this.readOnly) {
			$div.addClass('readOnly');
		}

		return $div.html();
	}
}
